module.exports = __webpack_public_path__ + "img/MU.ca7b8131.svg";